@if (rendering && viewModel$ | async; as vm) {
  <wl-calculate-card
    [title]="titleField"
    [subTitle]="descriptionField"
    [sticker]="sticker"
  >
    <form novalidate [wlTrackStep]="trackToolConfig.forStep('wizard')">
      @if (deliveryAddressTitleField) {
        <p class="mb-1 fw-bold" *scText="deliveryAddressTitleField"></p>
      }
      <wl-postal-address-form
        class="d-block mb-2"
        [trackStep]="trackToolConfig.forStep('wizard')"
        [rendering]="rendering"
        [content]="postalFormContent"
        [formState]="vm.formState"
      ></wl-postal-address-form>

      <div class="row g-1 mb-2 align-items-end">
        <div class="col-12">
          <div class="d-flex flex-row mb-1">
            <label
              class="mb-0 me-1 fw-bold"
              for="{{ vm.formState.controls?.consumption?.id }}"
              >{{ electricityUsageLabel }}</label
            >
            <wl-tooltip
              [tooltip]="{ description: electricityUsageTooltip }"
            ></wl-tooltip>
            <div class="flex-grow-1"></div>
            <button
              type="button"
              class="btn btn-link align-self-end p-0"
              (click)="openModal()"
              wlAutomationId="solar-panels-wizard-estimate-button"
            >
              {{ electricityEstimateButtonLabel }}
            </button>
          </div>
          <wl-input-group
            icon="plug"
            [suffix]="'ElectricityUsageUnit' | translate"
            [valid]="vm.formState.controls.consumption | isValid"
            [invalid]="vm.formState.controls.consumption | isInvalid"
          >
            <wl-number
              class="flex-grow-1"
              [step]="trackToolConfig.step('wizard')"
              [stepName]="trackToolConfig.stepName('wizard')"
              fieldName="stroomverbruik jaar"
              wlAutocomplete="electricity-usage"
              [rendering]="rendering"
              [formsControl]="vm.formState.controls.consumption"
              [placeholder]="electricityUsagePlaceholder"
              [floatingLabel]="true"
            ></wl-number>
          </wl-input-group>
        </div>
      </div>

      <div class="row g-1 mb-4 mt-3">
        <div class="col-12">
          <wl-radio
            [step]="trackToolConfig.step('wizard')"
            [stepName]="trackToolConfig.stepName('wizard')"
            [rendering]="rendering"
            [formsControl]="vm.formState.controls.houseType"
            [radioItems]="radioItems"
            [inline]="true"
          >
          </wl-radio>
        </div>
      </div>

      @if (!vm.addressCheck.hasErrored) {
        <div class="row g-1 mt-2 mb-1">
          <div class="col-12">
            <button
              (click)="submit($event, vm.formState.isValid)"
              wlTrackLink
              [trackLinkInfo]="{
                rendering: rendering,
                eventType: 'button-click',
                rendering: rendering,
                field: submitButtonTextField?.value,
              }"
              class="btn btn-sales-primary calculate__submit-button w-100"
              wlAutomationId="solar-panels-wizard-submit-button"
              *scText="submitButtonTextField"
            ></button>
          </div>
        </div>
        @if (secondaryButton.link && secondaryButton.link?.href) {
          <div class="row g-1 my-1">
            <div class="col-12">
              <a
                class="w-100"
                wlAutomationId="solar-panels-wizard-secondary-button"
                *wlGenericLink="secondaryButton.link"
                [ngClass]="['mb-0 mt-0', secondaryButton.style]"
                wlTrackLink
                [trackLinkInfo]="{
                  eventType: 'button-click',
                  rendering: rendering,
                  field: secondaryButton.link.href,
                }"
              ></a>
            </div>
          </div>
        }
      } @else {
        <wl-info-card
          wlAutomationId="solar-panels-wizard-submission-error"
          [title]="rendering.fields.SubmissionFailedTitle"
          [message]="rendering.fields.SubmissionFailedMessage"
          [shadow]="false"
          [type]="'danger'"
          [border]="true"
        >
        </wl-info-card>
        <div class="row g-1 mt-2 mb-1">
          <div class="col-12">
            <button
              (click)="submit($event, vm.formState.isValid)"
              wlTrackLink
              [trackLinkInfo]="{
                rendering: rendering,
                eventType: 'button-click',
                rendering: rendering,
                field: rendering.fields.RetryButtonText?.value,
              }"
              class="btn btn-sales-primary calculate__submit-button w-100"
              wlAutomationId="solar-panels-wizard-submit-button"
              *scText="rendering.fields.RetryButtonText"
            ></button>
          </div>
        </div>
      }
    </form>
  </wl-calculate-card>
}
